export default function Pinned() {
  return <div>Pinned</div>;
}
